import React, { useState } from "react";
import { MDBFooter, MDBContainer, MDBRow, MDBCol, MDBIcon } from "mdbreact";

import { Link } from "gatsby";
import Logo from "../../assets/images/home/logo_branco.svg";
import Emec from "../../assets/images/footer/e-mec.jpg";

import BgVestibular from "../../assets/gg/images/home/bgVestibular.png";
import { GGgetMode } from "../../services/gglocalstorage";

/**
 * Barra de navegação superior.
 */

export default function Footer() {
	return (
		<MDBFooter
			color="indigo"
			className="font-small pt-4"
			style={{
				backgroundImage: GGgetMode() && `url(${BgVestibular})`,
				backgroundSize: "cover",
			}}
		>
			<MDBContainer
				className="text-center text-md-left"
				style={{ color: "#fff" }}
			>
				<MDBRow>
					<MDBCol md="4">
						<h5 className="title">Converse com a gente</h5>
						<MDBRow>
							<MDBCol className="text-start p-3">
								<a
									href="https://api.whatsapp.com/send/?phone=555135868800&text&type=phone_number&app_absent=0"
									target="_blank"
									rel="noreferrer"
									className="px-3 btn rounded-circle bg-white"
								>
									<MDBIcon
										fab
										icon="whatsapp fa-4x"
										style={{ color: "#5ba82d" }}
									/>
								</a>
								<a
									href="https://www.instagram.com/feevale/"
									target="_blank"
									rel="noreferrer"
									className="px-3 btn rounded-circle bg-white"
								>
									<MDBIcon
										fab
										icon="instagram fa-4x"
										style={{ color: "#5ba82d" }}
									/>
								</a>
								<a
									href="https://www.tiktok.com/@feevale"
									target="_blank"
									rel="noreferrer"
									className="px-3 btn rounded-circle bg-white"
								>
									<MDBIcon
										fab
										icon="tiktok fa-4x"
										style={{ color: "#5ba82d" }}
									/>
								</a>
							</MDBCol>
						</MDBRow>
						<MDBRow>
							<MDBCol className="p-3">
								<ul className="p-0 ml-md-5">
									<li className="list-unstyled">
										<a
											href="tel:555135868800"
											style={{ color: "#fff" }}
											alt="telefone: (51) 3586.8800"
											title="(51) 3586.8800"
										>
											(51) 3586.8800
										</a>
									</li>
								</ul>
							</MDBCol>
						</MDBRow>
					</MDBCol>
					<MDBCol md="4">
						<h5 className="title">Acesso Rápido</h5>
						<ul className="p-0 ml-md-5">
							{/*<li className="list-unstyled">
								<Link className="text-white" to="/conheca-a-feevale-way">
									Conheça a Feevale Way
								</Link>
							</li>*/}
							<li className="list-unstyled">
								<Link style={{ color: "#fff" }} to="/cursos/">
									Cursos
								</Link>
							</li>
							<li className="list-unstyled">
								<Link style={{ color: "#fff" }} to="/descontos">
									Vantagens
								</Link>
							</li>
							<li className="list-unstyled">
								<Link style={{ color: "#fff" }} to="/contato">
									Contato
								</Link>
							</li>
							<li className="list-unstyled">
								<a
									href="/polos"
									rel="noreferrer"
									style={{ color: "#fff" }}
								>
									Polos
								</a>
							</li>
							<li className="list-unstyled">
								<a
									href="https://www.feevale.br"
									target="_blank"
									rel="noreferrer"
									style={{ color: "#fff" }}
								>
									Universidade Feevale
								</a>
							</li>
						</ul>
					</MDBCol>
					<MDBCol md="4" style={{ padding: "0px" }}>
						<a
							target="_blank"
							href="https://emec.mec.gov.br/emec/consulta-cadastro/detalhamento/d96957f455f6405d14c6542552b0f6eb/MjM="
						>
							<img
								src={Emec}
								className=""
								style={{ border: "2px solid #fff", padding: "5px" }}
							/>
						</a>
					</MDBCol>
				</MDBRow>
			</MDBContainer>
			<div className="text-center py-3">
				<MDBContainer fluid>
					<a href="https://www.feevale.br" rel="noreferrer" target="_blank">
						<img
							src={Logo}
							alt="Universidade Feevale"
							className="img-fluid"
							style={{ maxWidth: "180px" }}
						/>
					</a>
					<p className="mt-1" style={{ color: "#fff" }}>
						Todos os direitos reservados.
					</p>
				</MDBContainer>
			</div>
		</MDBFooter>
	);
}
